import { render, staticRenderFns } from "./bargainingOrder.vue?vue&type=template&id=2ccb6385&scoped=true"
import script from "./bargainingOrder.vue?vue&type=script&lang=js"
export * from "./bargainingOrder.vue?vue&type=script&lang=js"
import style0 from "./bargainingOrder.vue?vue&type=style&index=0&id=2ccb6385&prod&lang=less&scoped=true"
import style1 from "./bargainingOrder.vue?vue&type=style&index=1&id=2ccb6385&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ccb6385",
  null
  
)

export default component.exports